// extracted by mini-css-extract-plugin
module.exports = {"milestoneWrapper":"milestone_milestoneWrapper__19pOt","milestoneBackground":"milestone_milestoneBackground__1m7BF"};